import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import { distanceQuantityField } from './common/travelFields';
import { distanceUnitField } from './common/travelFields';

export const ceeFlightsMetadata = {
  displayName: msg({
    message: 'CEE Flights',
    context: 'Activity data schema name for CEE Flights',
  }),
  fields: {
    ...coreFields,
    ghg_category_id: ghgCategoryField,
    flight_type: {
      displayName: msg({
        message: 'Flight type',
        context: 'The type of flight.',
      }),
    },
    quantity: distanceQuantityField,
    unit: distanceUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
